import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { itemsFor, CarDamageDiagram } from "../VehicleDamageDiagram";

const Block = ({ title, insp, tid }) => (
  <div className="space-y-2 rounded-xl border border-slate-200 p-3" data-testid={tid}>
    <p className="text-sm font-bold text-slate-800">{title}{insp.kind === "moto" ? " · دراجة نارية" : " · سيارة"}</p>
    <div className="grid grid-cols-2 gap-x-3 gap-y-1">
      {itemsFor(insp.kind).map((it) => (
        <div key={it.key} className="flex items-center gap-1.5 text-[11px] text-slate-600">
          <span className={insp.checklist?.[it.key] ? "font-bold text-emerald-600" : "font-bold text-rose-500"}>{insp.checklist?.[it.key] ? "✓" : "✗"}</span>{it.label}
        </div>))}
    </div>
    {!!insp.damages?.length && <>
      <CarDamageDiagram kind={insp.kind} damages={insp.damages} />
      <ol className="list-decimal space-y-0.5 pr-5 text-[11px] text-slate-600">{insp.damages.map((d, i) => <li key={i}>{d.note || "ضرر"}</li>)}</ol>
    </>}
    {insp.note && <p className="text-[11px] text-slate-500">{insp.note}</p>}
  </div>
);

export const RentalInspectionView = ({ contract, onClose }) => (
  <Dialog open={!!contract} onOpenChange={(o) => !o && onClose()}>
    <DialogContent dir="rtl" className="max-h-[92vh] overflow-y-auto font-body sm:max-w-lg" data-testid="rental-inspection-view">
      <DialogHeader className="text-start"><DialogTitle>فحص المركبة — {contract?.number}</DialogTitle></DialogHeader>
      {contract?.handover_out?.inspection && <Block title="عند التسليم للمستأجر" insp={contract.handover_out.inspection} tid="rental-insp-out" />}
      {contract?.return_in?.inspection && <Block title="عند الاستلام (الإرجاع)" insp={contract.return_in.inspection} tid="rental-insp-in" />}
    </DialogContent>
  </Dialog>
);
